/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import { getCookie as getControlledCookie } from '@atlassian/browser-storage-controls/controllers/cookie-controls/get-cookie';
import { getSsrStatus } from '@jira/platform__conditional-ssr/src/get-ssr-status.tsx';

declare global {
	// global variables will only show up on GlobalThis with a var declaration
	// oxlint-disable-next-line vars-on-top
	var __GET_COOKIE__: (name?: string) =>
		| string
		| {
				[key: string]: string;
		  }
		| undefined;
}

export function getCookie(): { [key: string]: string };
export function getCookie(key: string, ssr?: boolean): string | undefined; // This is used in index.server.tsx
export function getCookie(key?: string): string;
export function getCookie(
	key?: string,
	ssr?: boolean,
): string | undefined | { [key: string]: string } {
	if (__SERVER__) {
		if (ssr) {
			if (getSsrStatus() === 'static') {
				return key ? getControlledCookie(key) : undefined;
			}
			// Defined here jira/src/entry-fs/utils/single-spa-route.tsx
			return globalThis?.__GET_COOKIE__?.(key);
		}
		return;
	}
	return key ? getControlledCookie(key) : getControlledCookie();
}
